import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import OrderService from "services/OrderService";

export const initialState = {
  loading: false,
  message: "",
  list: null,
  subloading: false,
};

export const stockListAll = createAsyncThunk("/stock/list", async (data, { rejectWithValue }) => {
    try {
      const response = await OrderService.getStock(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const stockSlice = createSlice({
  name: "stock",
  initialState,
  reducers: {
    stockList: (state, action) => {
      state.loading = true;
      state.list = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(stockListAll.pending, (state) => {
        state.loading = false;
      })
      .addCase(stockListAll.fulfilled, (state, action) => {
        state.loading = true;
        state.list = action.payload;
      });
  },
});

export const { stockList } = stockSlice.actions;

export default stockSlice.reducer;
